<template>
  <div
    style="
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      height: 100%;
      min-height: 62px;
    "
  >
    <div>
      {{ item.phone ? item.phone : '-' }}
    </div>
    <div>
      {{ item.address ? item.address : '-' }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: Object
  }
}
</script>
